import React from 'react';
import Select, { selectType } from 'Components/Select';
import RowsSelector from 'Components/RowsSelector';
import { ROLES } from 'constants/roles'
import { stopPropagation } from 'helpers';
import YearPicker from 'Components/YearPicker';

const filterOptions = {
  active: [
    {name: 'All', value: 'All'}, {name: 'Active', value: true}, {name: 'Inactive', value: false}
  ],
  allRoles:[
    {name: 'All', value: 'All'}, {name: 'Oil formulator', value: ROLES.OIL_MANUFACTURER.serverName}, {name: 'Oil brander', value: ROLES.OIL_BRANDER.serverName}
  ],
  isCertified: [
    {name: 'All', value: 'All'}, {name: 'Certified', value: true}, {name: 'Certification Pending', value: false}
  ],
  isPaid: [
    {name: 'All', value: 'All'}, {name: 'Paid', value: true}, {name: 'Unpaid', value: false}
  ],
  brandSignStatus: [
    {name: 'All', value: 'All'}, {name: 'Signed', value: true}, {name: 'Not signed', value: false}
  ],
};



export default ({
  filterState,
  handleSelectFilter,
  user,
  outCount,
  handleRowCountSelect,
  rowsCount,
  isOilDashboard,
  checklistItems,
  additionalFilterState,
  handleSelectAdditionalFilter,
  toggleAdditionalFilterItem,
  clearAdditionalFilter,
  //TODO: implement eslint rule for unused arguments
  isWithPaymentStatus,
  isWithCertificationStatus,
  currentYear,
  selectedYear,
  handleYearSelect,
  listRequestInProcess,
}) => {
  const additionalFiltersItemsNames = Object.keys(additionalFilterState);

  const getSelectedItem = key => {
    if (filterState[key] === undefined) return filterOptions[key][0];
    return filterOptions[key].find(item => item.value === filterState[key]);
  };

  return (
    <React.Fragment>
      <section className='list-scene__utility-section-wrapper'>
        <section className='list-scene__utility-section-filters-wrapper'>
          <div className='list-scene__utility-section-filters-header _margin_left_10'>Year select</div>
          <YearPicker
            endYear={currentYear + 1}
            startYear={currentYear - 20}
            yearPickAction={handleYearSelect}
            label='Checklist Items Year'
            year={selectedYear ? Number(selectedYear) : undefined}
            width={160}
            height={18}
            disabled={listRequestInProcess}
          />
        </section>
        {!user.isInspector() && (
          <section className='list-scene__utility-section-filters-wrapper'>
            <div className='list-scene__utility-section-filters-header _margin_left_10'>Filter</div>
            <Select
              selectionList={filterOptions.active}
              handleSelect={handleSelectFilter('active')}
              defaultItem={getSelectedItem('active')}
              isSlave
              itemNameIndicator='name'
              label={'by Status'}
              type={selectType.listFilter}
            />
            {isOilDashboard && (
              <React.Fragment>
                <Select
                  selectionList={filterOptions.allRoles}
                  handleSelect={handleSelectFilter('allRoles')}
                  defaultItem={getSelectedItem('allRoles')}
                  isSlave
                  itemNameIndicator='name'
                  label={'by Type'}
                  type={selectType.listFilter}
                />
                <Select
                  selectionList={filterOptions.brandSignStatus}
                  handleSelect={handleSelectFilter('brandSignStatus')}
                  defaultItem={getSelectedItem('brandSignStatus')}
                  isSlave
                  itemNameIndicator='name'
                  label={'by Agreement Status'}
                  type={selectType.listFilter}
                />
              </React.Fragment>
            )}
          </section>
        )}
        {!!checklistItems.length && (
          <section className='list-scene__utility-section-filters-wrapper'>
            <div className='list-scene__utility-section-filters-header _margin_left_10'>Additional Filters</div>
            <Select
              selectionList={checklistItems}
              handleSelect={handleSelectAdditionalFilter}
              defaultItem=''
              multiSelect
              withCheckBoxes
              itemNameIndicator='name'
              placeholder={
                additionalFiltersItemsNames.length ? `${additionalFiltersItemsNames.length} is selected` : 'None'
              }
              mainWrapperClassName='_margin_top_12'
              dropDownClassName='_top_22'
              type={selectType.listFilter}
            />
          </section>
        )}
        <div className='list-scene__utility-section-rows-select-wrapper'>
          <RowsSelector allRowsCount={outCount} handleRowsSelect={handleRowCountSelect} selectedRowsCount={rowsCount} />
        </div>
      </section>

      {!!additionalFiltersItemsNames.length && (
        <section className='list-scene__additional-filters-bubbles-wrapper'>
          <div className='list-scene__bubble-hover-wrapper'>
            <div
              className='list-scene__additional-filter-bubble _text-decoration_underline'
              onClick={clearAdditionalFilter}
            >
              Clear All
            </div>
          </div>
          {additionalFiltersItemsNames.map(filterItemName => {
            return (
              <div key={filterItemName} className='list-scene__bubble-hover-wrapper'>
                <div
                  className={`list-scene__additional-filter-bubble ${
                    additionalFilterState[filterItemName]
                      ? 'list-scene__additional-filter-bubble_true'
                      : 'list-scene__additional-filter-bubble_false'
                  }`}
                  onClick={toggleAdditionalFilterItem(filterItemName)}
                >
                  <div className='__up-down-arrows-icon _display_none _position_absolute _left_5 _top_2' />
                  {filterItemName}
                </div>
                <div
                  className='boat-systems-scene__banner-delete-button _top_5 _right_10'
                  onClick={event => {
                    stopPropagation(event);
                    handleSelectAdditionalFilter({ name: filterItemName });
                  }}
                />
              </div>
            );
          })}
        </section>
      )}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/DashboardScene/Header.jsx